var _classCallCheck = require("/Users/kirill.kulakov/muscle_spelling/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/kirill.kulakov/muscle_spelling/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 *
 * Jabber, tiny library to generate random real like words / sentences lipsum / lorem ipsum
 *
 *
 */
var consonants = 'bcdfghjklmnpqrstvwxyzbpcrtpcrddrtplmnplmnbbcbcdrbnmklhgd';
var vowels = 'aeiou';
/**
 * Jabber Class
 * class definition
 */

var Jabber =
/*#__PURE__*/
function () {
  "use strict";

  /**
   *
   * @param themeWords Custom words that need to appear in some density
   * @param themeWordDensity appearance of themeword 1 per this number so 5 will make it approx 1 per 5 words
   */
  function Jabber() {
    var themeWords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var themeWordDensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

    _classCallCheck(this, Jabber);

    this.themeWords = themeWords;
    this.themeWordDensity = themeWordDensity;
  }
  /**
   * Create word of certain length
   * @param length
   * @returns {string}
   */


  _createClass(Jabber, [{
    key: "createWord",
    value: function createWord(length, capitalize) {
      var word = '';

      if (this.themeWords.length && Math.floor(Math.random() * this.themeWordDensity) < 1) {
        word = this.themeWords[Math.floor(Math.random() * this.themeWords.length)];
      } else {
        var currently = 'consonants';

        for (var i = 0; i < length; i++) {
          if (currently === 'consonants') {
            word += consonants.substr(Math.floor(Math.random() * consonants.length), 1);
            currently = 'vowels';
          } else {
            word += vowels.substr(Math.floor(Math.random() * vowels.length), 1);
            currently = 'consonants';
          }
        }
      }

      if (capitalize) {
        word = this._jsUcfirst(word);
      }

      return word;
    }
    /**
     * Create paragraph of certain number of words
     * @param length
     * @returns {string}
     */

  }, {
    key: "createParagraph",
    value: function createParagraph(length) {
      var paragraph = '';
      var capitalizeNextWord = true;

      for (var i = 0; i < length; i++) {
        paragraph += this.createWord(2 + Math.floor(Math.random() * 9), capitalizeNextWord);

        if (Math.floor(Math.random() * 9) < 1) {
          paragraph += '. ';
          capitalizeNextWord = true;
        } else {
          paragraph += ' ';
          capitalizeNextWord = false;
        }
      }

      return paragraph.trim() + '.';
    }
  }, {
    key: "_jsUcfirst",
    value: function _jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }]);

  return Jabber;
}();

module.exports = Jabber;